import { useNavigate } from 'react-router'
import { Box, Button, Grid, Link, Typography, useMediaQuery } from '@mui/material'

import BackButton from '../../../components/back-button'
import ScreenContainer from '../../../components/screen'
import SensorActivationFooter from '../../../components/sensor-activation-footer'
import placementSuggestionFlat from '../../../images/placement-suggestion-flat.svg'
import placementSuggestionUpright from '../../../images/placement-suggestion-upright.svg'
import { useActivationContext } from '../../../providers/activation-provider'
import { SHORT_SCREEN_HEIGHT } from '../../../utils/constants'
import useStyles from '../index.styles'

const PlacementSuggestionsSlim = () => {
  const classes = useStyles
  const navigate = useNavigate()
  const { activationLocationState } = useActivationContext()
  const isShortScreen = useMediaQuery(`(max-height:${SHORT_SCREEN_HEIGHT})`)

  return (
    <ScreenContainer
      useDarkBackground={true}
      headerProps={{
        showDownloadAppButton: false,
        leftIcon: <BackButton />,
        useDarkBackground: true,
        progress: 79,
      }}
      footerSpacing={148}
    >
      <Grid container={true} sx={[classes.slimOuterContainer, classes.placementSuggestionsContainer]}>
        <Grid container={true} sx={isShortScreen ? classes.slimSectionWithMargin(true) : classes.slimSection}>
          <Box sx={classes.imageContainer}>
            <img src={placementSuggestionUpright} alt="" style={classes.sensorImg} />
          </Box>

          <Grid container={true} sx={classes.slimTextColumn}>
            <Typography
              variant="h6"
              sx={(theme) => ({
                ...classes.text,
                ...classes.textEmphasis,
                ...(isShortScreen && classes.shortScreenMargin(theme)),
              })}
            >
              Placing upright?
            </Typography>

            <Typography variant="h6" sx={classes.text}>
              Leak pins should{' '}
              <Box component="span" sx={classes.textEmphasis}>
                face downward
              </Box>
            </Typography>

            <Typography variant="h6" sx={classes.text}>
              Use back tape if needed
            </Typography>
          </Grid>
        </Grid>

        <Grid container={true} sx={classes.slimSection}>
          <Box sx={classes.imageContainer}>
            <img src={placementSuggestionFlat} alt="" style={classes.sensorImg} />
          </Box>

          <Grid container={true} sx={classes.slimTextColumn}>
            <Typography
              variant="h6"
              sx={(theme) => ({
                ...classes.text,
                ...classes.textEmphasis,
                ...(isShortScreen && classes.shortScreenMargin(theme)),
              })}
            >
              Laying flat?
            </Typography>

            <Typography variant="h6" sx={classes.text}>
              Leak pins should{' '}
              <Box component="span" sx={classes.textEmphasis}>
                face outward
              </Box>
            </Typography>
          </Grid>
        </Grid>
      </Grid>

      <SensorActivationFooter
        primaryButton={
          <Button variant="contained" color="secondary" disableElevation onClick={() => navigate('/sensor-location', { state: activationLocationState })}>
            I placed my sensor
          </Button>
        }
        secondaryButton={
          <Link href="https://resources.meshify.com/defender-slim/placement-suggestions/" rel="noopener noreferrer" target="_blank" underline="hover">
            See more placement tips
          </Link>
        }
      />
    </ScreenContainer>
  )
}

export default PlacementSuggestionsSlim
